module.exports = __webpack_public_path__ + "img/yanxue.a61fcbc7.jpeg";